var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightAlign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 48,
    viewBox: "0 0 78 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    y: 0.5,
    width: 76.1035,
    height: 47,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.699219,
    y: 0.5,
    width: 76.1035,
    height: 47,
    stroke: "#4A4458"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3027,
    y: 4,
    width: 34,
    height: 24,
    fill: "#CCA3CF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 69.1035,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 33.1431)",
    fill: "#CCA3CF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 69.1035,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 38.5718)",
    fill: "#CCA3CF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 69.1035,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 44)",
    fill: "#CCA3CF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 6)",
    fill: "#CCA3CF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 11.5)",
    fill: "#CCA3CF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 17)",
    fill: "#CCA3CF"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 22.5)",
    fill: "#CCA3CF"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 2,
    transform: "matrix(1 0 0 -1 4.19922 28)",
    fill: "#CCA3CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlign);
export default __webpack_public_path__ + "static/media/RightAlign.1c883c17da70cf9a4c7821adb703c0f7.svg";
export { ForwardRef as ReactComponent };